export default function NervousPatients() {
  return (
    <section className="py-20 bg-white" id="nervous-patients">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] mb-6">
              <strong>Specialized Care for Anxious Dental Patients in Chelmsford</strong>
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              We understand that visiting the dentist can be stressful for many people. At Beaulieu Dental, our entire team specializes in providing gentle, compassionate care for <strong>anxious dental patients</strong> throughout Chelmsford and Essex.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Our experienced team, led by Dr. Yasir Saeed with 30+ years of expertise, is known for their gentle approach and exceptional care with nervous and trauma-experienced patients. We take the time to listen to your concerns and work at your pace.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-pulse-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#444c42] mb-2">
                    <strong>Dental Sedation in Chelmsford</strong>
                  </h3>
                  <p className="text-gray-600">
                    We offer safe <strong>dental sedation options in Chelmsford</strong> to help you feel completely relaxed during treatment. From conscious sedation to IV sedation, we'll find the right solution for your anxiety level.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#444c42] mb-2">Patient-Paced Treatment</h3>
                  <p className="text-gray-600">
                    We never rush. Our team takes the time to explain every step, answer all your questions, and ensure you feel comfortable before proceeding with any treatment.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#444c42] mb-2">Gentle, Compassionate Team</h3>
                  <p className="text-gray-600">
                    Every member of our team is trained in anxiety management and committed to making your experience as comfortable and stress-free as possible.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-heart-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#444c42] mb-2">Trauma-Informed Care</h3>
                  <p className="text-gray-600">
                    Our team has extensive experience working with patients who have had negative dental experiences in the past. We're here to rebuild your trust and confidence.
                  </p>
                </div>
              </div>
            </div>

            <button
              onClick={() => {
                const element = document.getElementById('booking');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-[#D0A24F] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#F5d383] transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Book Your Anxiety-Free Consultation
            </button>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/0a3008c36638439fa5d134c9c6a19be7/d39930ac071bfdc1c65fe52428a95692.jpeg"
                alt="Anxious Dental Patients Care in Chelmsford - Dental Sedation"
                title="Specialized Care for Anxious Dental Patients | Dental Sedation Chelmsford"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[#D0A24F] text-white p-6 rounded-xl shadow-xl max-w-xs">
              <p className="text-2xl font-bold mb-2">98% Patient Satisfaction</p>
              <p className="text-sm">
                <strong>Anxious dental patients</strong> consistently rate our gentle approach and <strong>dental sedation services</strong> as exceptional
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
